import React, { useState, useEffect } from 'react';
import MainLayout from '../components/MainLayout';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { HTTP_STATUS } from '../utils/httpStatusCodes';
import { useLocation, useNavigate } from 'react-router-dom';
import AddDeliveryAddressModal from '../components/modals/AddDeliveryAddressModal';
import GuardedNavigationModal from '../components/modals/GuardedNavigationModal';
import useNavigationGuard from '../hooks/useNavigationGuard'

const DeliveryAddress = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentCustomerId, setCurrentCustomerId] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [customerInfo, setCustomerInfo] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile: ''
  });
  const { showModal, confirmNavigation, cancelNavigation, guardedNavigate } = useNavigationGuard(true);

  useEffect(() => {
    const orderId = location.state?.order_id || localStorage.getItem('current_order_id');
    const customerId = location.state?.customer_id || localStorage.getItem('current_customer_id');
    setCurrentOrderId(orderId);
    setCurrentCustomerId(customerId);

    fetchCustomerDetails(customerId);
    fetchAddresses(customerId);
  }, []);

  const fetchCustomerDetails = async (customerId) => {
    const res = await callAPI(apiUrls.CUSTOMER_DETAILS,{ current_customer_id: customerId }, 'GET');
    if (res.status === HTTP_STATUS.OK) {
      const customer = res.data.data?.customer;
      setCustomerInfo({
        first_name: customer.firstName,
        last_name: customer.lastName,
        email: customer.email,
        mobile: customer.contactNumber
      });
    }
  };

  const fetchAddresses = async (customerId) => {
    const res = await callAPI(apiUrls.CUSTOMER_DELIVERY_ADDRESS, { current_customer_id: customerId } , 'GET');
    if (res.status === HTTP_STATUS.OK) {
      const deliveryAddresses = res.data.data?.delivery_address || [];
      setAddresses(deliveryAddresses);
      if (deliveryAddresses.length > 0) {
        setSelectedAddressId(deliveryAddresses[0].id);
      }
    }
  };


  const handleAddAddressSubmit = async (formData) => {
    formData.selected_customer_id = currentCustomerId;
    try {
      const response = await callAPI(apiUrls.SAVE_DELIVERY_ADDRESS, {}, 'POST', formData, {});
      if (response.status === HTTP_STATUS.OK) {
        if (response.data?.errors) {
          return { success: false, errors: response.data.errors };
        } else {
          await fetchAddresses(currentCustomerId);
          return { success: true };
        }
      } else {
        return { success: false, errors: { general: ['Something went wrong. Please try again.'] } };
      }
    } catch (error) {
      if (error.response && error.response.data?.data?.errors) {

        return { success: false, errors: error.response.data.data.errors };
      } else {
        return { success: false, errors: { general: ['Something went wrong. Please try again.'] } };
      }
    }
  };
  
  

  const proceedToPay = async () => {
    if (!selectedAddressId) {
      alert('Please select a delivery address');
      return;
    }
  
    try {
      const payload = {
        address_id: selectedAddressId,
        order_id: currentOrderId
      };
  
      const response = await callAPI(
        apiUrls.SET_ORDER_ADDRESS,
        {},
        'POST',
        payload,
        {}
      );
  
      if (response.status === HTTP_STATUS.OK) {
        const navState = {
          customer_id: currentCustomerId,
          order_id: currentOrderId,
        };
  
        navigate('/payment-view?order_id=' + currentOrderId, { state: navState });
      } else {
        alert('Failed to set delivery address');
      }
    } catch (error) {
      console.error('Error setting address:', error);
      alert('Something went wrong. Please try again.');
    }
  };
  
  const customFooterButtons = (
    <>
      <button className="btn iconBtn btnLight" onClick={() => setModalOpen(true)}>
        Add Delivery Address
      </button>
      <button className="btn iconBtn btnPrimary" onClick={proceedToPay}>
        Proceed to Pay
      </button>
    </>
  );

  return (
    <MainLayout  guardedNavigate={guardedNavigate} footerButtons={customFooterButtons}>
      <div className="pageContent transferOptionsPage dflexCol">
        <div className="container">
          <div className="selectCustomerCol dladdress">
            <h4 className="lgTitle text-center pb-3">Select Delivery Address</h4>
            <form className="formStyle pt-2 pt-md-4 mt-md-3">
              <div className="col-12">
                <p className="fw-medium mb-2">
                  {customerInfo.first_name} {customerInfo.last_name}
                </p>
                <p className="pb-3">
                  {customerInfo.email}, {customerInfo.mobile}
                </p>

                {addresses.length === 0 && <p>No delivery addresses found.</p>}

                {addresses.map((address, index) => (
                  <div className="form-check mb-4" key={address.id}>
                    <input
                      className="form-check-input"
                      type="radio"
                      name="serviceType"
                      id={`serviceType${index}`}
                      checked={selectedAddressId === address.id}
                      onChange={() => setSelectedAddressId(address.id)}
                    />
                    <label className="form-check-label" htmlFor={`serviceType${index}`}>
                      <span>{address.full_address}</span>
                      {address.distance_from_restaurant_in_kms > 0 && (
                        <span>{parseFloat(address.distance_from_restaurant_in_kms).toFixed(2)} Kms</span>
                      )}
                    </label>
                  </div>
                ))}
              </div>
            </form>
          </div>
        </div>
      </div>

      <AddDeliveryAddressModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSubmit={handleAddAddressSubmit}
        customerInfo={customerInfo}
      />
            <GuardedNavigationModal 
            isOpen={showModal} 
            onCancel={cancelNavigation} 
            onConfirm={confirmNavigation} 
        />

    </MainLayout>
  );
};

export default DeliveryAddress;
